// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { pushOrder, selectPushOrderLoading } from '../../feature';

// Modules
import { Header } from '@/modules/Layout';

//Components
import { showSuccessToast, useForm } from '@/components';
import { StyledContainer, StyledPushOrderForm } from './PushOrdersContainerStyles';

// Helpers
import { PushOrderFormFields, TPushOrderFormValues } from '../../helpers';

const PushOrdersContainer: FC = () => {
  const { t } = useTranslation(['common']);
  const dispatch = useAppDispatch();
  const isLoading = useAppState(selectPushOrderLoading);
  const [formInstance] = useForm();

  const handlePushOrder = async (values: TPushOrderFormValues) => {
    try {
      await dispatch(pushOrder(values)).unwrap();
      formInstance.resetFields();
      showSuccessToast({ message: t('message_push_order_success', { orderId: values[PushOrderFormFields.ORDER_ID] }) });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Header title={t('menu_push_orders')} />
      <StyledContainer>
        <StyledPushOrderForm form={formInstance} isLoading={isLoading} onSubmit={handlePushOrder} />
      </StyledContainer>
    </>
  );
};

export default PushOrdersContainer;
